import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Route guards — separation stricte admin / client.
 *
 * Strict rules (prevent cross-role flash):
 *  - AdminRoute  : admin connecte → children. Sinon → /admin/login (jamais /portal).
 *  - PortalRoute : client connecte → children. Sinon → /portal (jamais /admin).
 *
 * Cela empeche toute redirection vers l'espace inverse pendant la resolution
 * de session, ce qui est la cause du "flash admin" observe en preview.
 */

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (user) return children;
  return <Navigate to="/admin/login" replace />;
};

export const PortalRoute = ({ children }) => {
  const { portalUser, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (portalUser) return children;
  return <Navigate to="/portal" replace />;
};

export const PortalRouteWithPasswordCheck = ({ children }) => {
  const { portalUser, mustChangePassword, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!portalUser) return <Navigate to="/portal" replace />;
  if (mustChangePassword) return <Navigate to="/portal/change-password" replace />;
  return children;
};

/**
 * Neutral full-page loader that matches NEITHER admin nor portal visuals,
 * so the user sees a plain brand-neutral screen while auth resolves.
 */
function FullPageLoader() {
  return (
    <div
      className="min-h-screen w-full flex items-center justify-center bg-gray-50"
      data-testid="auth-loader"
    >
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-3 border-gray-200 border-t-gray-500 rounded-full animate-spin" />
        <p className="text-xs text-gray-400">Chargement...</p>
      </div>
    </div>
  );
}
